import { NavLink } from 'react-router-dom';

import { cn } from '@/components/cn';

const ITEMS = [
  {
    to: '/',
    label: 'Dashboard',
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <rect x="3" y="3" width="7" height="7" rx="1.5" />
        <rect x="14" y="3" width="7" height="7" rx="1.5" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" />
        <rect x="14" y="14" width="7" height="7" rx="1.5" />
      </svg>
    ),
  },
  {
    to: '/assets',
    label: 'Assets',
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        aria-hidden
      >
        <rect x="3" y="5" width="18" height="3" rx="1.5" />
        <rect x="3" y="11" width="13" height="3" rx="1.5" />
        <rect x="3" y="17" width="8" height="3" rx="1.5" />
      </svg>
    ),
  },
  {
    to: '/insights',
    label: 'Insights',
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
      </svg>
    ),
  },
  {
    to: '/rentvest',
    label: 'Rentvest',
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    to: '/fire',
    label: 'FIRE',
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M14.5 2C13 6 10 9 10 13a4 4 0 0 0 8 0c0-4-2-7-3.5-11z" />
        <path d="M13 22c-2 0-3.5-1-4.5-3" />
        <path d="M13 22c2 0 3.5-1 4.5-3" />
        <path d="M8 18c-3-1-4-3-4-5" />
        <path d="M18 18c3-1 4-3 4-5" />
      </svg>
    ),
  },
  {
    to: '/rebalance',
    label: 'Rebalance',
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 2a10 10 0 0 1 7 17H5A10 10 0 0 1 12 2z" />
        <path d="M12 2v20" />
        <path d="M2 12h20" />
      </svg>
    ),
  },
];

/** Desktop side navigation — hidden below md. */
export const Sidebar = () => {
  return (
    <nav
      aria-label="Primary"
      className="hidden md:flex md:w-52 md:shrink-0 md:flex-col md:gap-1 md:py-2"
    >
      {ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          className={({ isActive }) =>
            cn(
              'flex items-center gap-3 rounded-button px-4 py-2.5 text-nav font-semibold transition-all duration-150',
              isActive ? 'bg-lav/40 text-ink' : 'text-warm-500 hover:bg-ink/[0.05] hover:text-ink',
            )
          }
        >
          {item.icon}
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
};
